import { Avatar, Box, Icon, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { ptBR } from "@mui/x-data-grid/locales";
import { useRewards } from "./useRewards";

const renderHeader = function () {
  return (
    <Typography variant="caption" color="secondary" fontSize={14}>
      {this.headerName}
    </Typography>
  );
};

const columns = [
  {
    field: "imageUrl",
    headerName: "Imagem",
    renderHeader,
    renderCell: ({ row }) => {
      return (
        <GridActionsCellItem
          disabled
          icon={<Avatar sx={{ width: 24, height: 24 }} src={row.imageUrl} />}
          label="Detalhes"
        />
      );
    },

    width: 80,
  },
  {
    field: "title",
    headerName: "PRÊMIO",
    renderHeader,
    width: 180,
  },
  {
    field: "description",
    headerName: "DETALHES DO PRODUTO",
    renderHeader,
    width: 280,
  },
  {
    field: "groupCode",
    headerName: "GRUPO",
    renderHeader,
    width: 180,
  },
  {
    field: "requiredPoints",
    headerName: "PONTOS NECESSÁRIOS",
    renderHeader,
    width: 140,
  },
  {
    field: "quantity",
    headerName: "DISPONÍVEIS",
    renderHeader,
    width: 140,
  },
  {
    field: "date",
    headerName: "DATA DE CADASTRO",
    renderHeader,
    width: 180,
  },
  {
    field: "createdBy",
    headerName: "QUEM CADASTROU",
    renderHeader,
    width: 180,
  },
  {
    field: "updatedAt",
    headerName: "ÚLTIMA ALTERAÇÃO",
    renderHeader,
    width: 180,
  },
  {
    field: "updatedBy",
    headerName: "QUEM FEZ A ÚLTIMA ALTERAÇÃO",
    renderHeader,
    width: 180,
  },
  {
    field: "actions",
    headerName: "AÇÕES",
    type: "actions",
    renderHeader,
    getActions: ({ row }) => [
      <Tooltip title="Remover apenas um item do grupo">
        <GridActionsCellItem
          icon={<Icon>delete</Icon>}
          label="Remover um item"
          onClick={row.removeOne}
        />
      </Tooltip>,
      <Tooltip title="Remover grupo inteiro">
        <GridActionsCellItem
          icon={<Icon>delete_sweep</Icon>}
          label="remover todos"
          onClick={row.removeAll}
        />
      </Tooltip>,
    ],
    width: 200,
  },
];

export default function RewardsList() {
  const { request, onNextPage } = useRewards();

  const { data, loading, page, limit, currentPage, totalPages, totalItems } =
    request;

  return (
    <Box sx={{ height: 500, flex: 1 }}>
      <DataGrid
        initialState={{
          columns: {
            columnVisibilityModel: {
              // Hide columns status and traderName, the other columns will remain visible
              updatedAt: false,
              updatedBy: false,
              createdBy: false,
            },
          },
        }}
        disableColumnResize
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        loading={loading}
        paginationMode="server"
        rowHeight={36}
        rows={data}
        isRowSelectable={false}
        columns={columns}
        pageSizeOptions={[...new Set([limit, 5, 10, 20, 50, 100])]}
        autoPageSize
        rowCount={totalItems || 0}
        paginationModel={{ page, pageSize: limit }}
        onPaginationModelChange={onNextPage}
        rowsPerPageOptions={[...new Set([limit, 5, 10, 20, 50, 100])]}
        disableSelectionOnClick
        pagination
      />
    </Box>
  );
}
